import { render, staticRenderFns } from "./AutoDetailsIcon.vue?vue&type=template&id=2754bb13&"
import script from "./AutoDetailsIcon.vue?vue&type=script&lang=js&"
export * from "./AutoDetailsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports